import { VariantByIndex, VariantName } from "@sphtech/dmg-design-system";

export function getVariantByIndex(
  config: {
    variantsByIndex?: VariantByIndex[];
    defaultVariant: VariantName;
  },
  index: number,
) {
  if (!config.variantsByIndex) {
    return config.defaultVariant;
  }

  const variantMap = new Map(config.variantsByIndex);

  return variantMap.get(index) || config.defaultVariant;
}
